/** 仅管理 access 无感刷新的 setTimeout，避免 store 与 request 循环依赖 */

let proactiveTimerId = null;

export function clearProactiveAccessRefreshTimer() {
  if (proactiveTimerId != null) {
    clearTimeout(proactiveTimerId);
    proactiveTimerId = null;
  }
}

/**
 * @param {number} delayMs
 * @param {() => void} fn 由调用方包一层 async，内部自行 catch
 */
export function armProactiveAccessRefreshTimer(delayMs, fn) {
  clearProactiveAccessRefreshTimer();
  if (typeof fn !== 'function' || !Number.isFinite(delayMs) || delayMs < 0) return;
  proactiveTimerId = setTimeout(() => {
    proactiveTimerId = null;
    fn();
  }, delayMs);
}
